/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Toast_Failed_Delete_Some_ItemsInputs */



/**
* | output |
* | --- |
* | "Failed to delete some items" |
*
* @param {Spaces_Toast_Failed_Delete_Some_ItemsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_toast_failed_delete_some_items = /** @type {((inputs?: Spaces_Toast_Failed_Delete_Some_ItemsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Toast_Failed_Delete_Some_ItemsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Löschen einiger Elemente fehlgeschlagen")
	return /** @type {LocalizedString} */ ("Failed to delete some items")
});